import { makeStyles, tokens } from '@fluentui/react-components'

export const useSettingsStyles = makeStyles({
  itemText: {
    margin: '0',
    paddingLeft: '46px', // Note: No token available for 46px
  },
  submenuHeader: {
    display: 'flex',
    flexDirection: 'row',
    width: '151px', // Note: No token available for 151px
    margin: '0',
    padding: `${tokens.spacingVerticalXXL} ${tokens.spacingHorizontalL} ${tokens.spacingVerticalL} ${tokens.spacingHorizontalL}`,
    paddingLeft: `${tokens.spacingHorizontalL}`, // force overwrite
    justifyContent: 'start',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  languageItem: {
    width: '100%',
    minHeight: '48px', // Note: No token available
    // Keep Fluent horizontal padding so the selected indicator stays visible.
    paddingBlock: tokens.spacingVerticalS,
    marginLeft: '0',
    '&[aria-current="page"] .fui-Body1': {
      fontWeight: tokens.fontWeightSemibold,
    },
  },
  languageItemTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    margin: '0',
    paddingLeft: '46px', // Note: No token available
  },
})
